import { connect } from 'react-redux';
import { mapWidgetTitle } from '../../../helpers/dashboard';

const mapStateToProps = ({ statusData, digitalCoach }, { title }) => ({
  title: mapWidgetTitle(title, statusData.parsedStatuses, digitalCoach)
});

export const withTitleMapper = connect(mapStateToProps);
